import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMapPinFlat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"map-pin-flat, route"} maskId="square-filled-radius-0-stroke-1-IconMapPinFlat"><path d="M14 6.93C14 4.76 15.79 3 18 3C20.21 3 22 4.76 22 6.93C22 10.06 18.37 11.87 18.22 11.95L18 12.06L17.78 11.95C17.63 11.87 14 10.06 14 6.93ZM21 20H6C4.9 20 4 19.1 4 18C4 16.9 4.9 16 6 16H9V7H13V6H9V3H6C4.35 3 3 4.35 3 6V18C3 19.65 4.35 21 6 21H22V11H21V20Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMapPinFlat;
